import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from 'components/AppIcon';

const QuickActions = () => {
  const navigate = useNavigate();

  const quickActions = [
    {
      id: 1,
      title: "New Case",
      description: "Create a new case file",
      icon: "Plus",
      color: "bg-primary text-white hover:bg-primary-700",
      route: "/case-management"
    },
    {
      id: 2,
      title: "Add Client",
      description: "Register new client",
      icon: "UserPlus",
      color: "bg-success text-white hover:bg-success-700",
      route: "/client-management"
    },
    {
      id: 3,
      title: "Create Invoice",
      description: "Generate client invoice",
      icon: "FileText",
      color: "bg-warning-500 text-white hover:bg-warning-600",
      route: "/dashboard"
    },
    {
      id: 4,
      title: "Upload Document",
      description: "Add case documents",
      icon: "Upload",
      color: "bg-secondary-600 text-white hover:bg-secondary-700",
      route: "/document-management"
    },
    {
      id: 5,
      title: "Schedule Meeting",
      description: "Book client appointment",
      icon: "Calendar",
      color: "bg-primary-600 text-white hover:bg-primary-700",
      route: "/dashboard"
    },
    {
      id: 6,
      title: "Generate Report",
      description: "Create practice reports",
      icon: "BarChart3",
      color: "bg-accent text-white hover:bg-accent-700",
      route: "/dashboard"
    }
  ];

  const handleActionClick = (route) => {
    navigate(route);
  };

  return (
    <div className="bg-surface rounded-lg shadow-card border border-border">
      <div className="p-6 border-b border-border">
        <h2 className="text-lg font-heading font-semibold text-text-primary">Quick Actions</h2>
        <p className="text-sm text-text-secondary mt-1">Common tasks and shortcuts</p>
      </div>

      <div className="p-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4">
          {quickActions.map((action) => (
            <button
              key={action.id}
              onClick={() => handleActionClick(action.route)}
              className={`${action.color} rounded-lg p-4 transition-smooth focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary group`}
            >
              <div className="flex flex-col items-center text-center">
                <div className="w-12 h-12 rounded-full bg-white bg-opacity-20 flex items-center justify-center mb-3 group-hover:bg-opacity-30 transition-smooth">
                  <Icon name={action.icon} size={24} />
                </div>
                <h3 className="font-medium text-sm mb-1">{action.title}</h3>
                <p className="text-xs opacity-90">{action.description}</p>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default QuickActions;